import React,{ useState, useEffect, useRef } from 'react';
import { useNavigate  } from 'react-router-dom';
import { Input, Row, Col, Divider } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

import AutoSwitching from '../../../components/AutoSwitching/AutoSwitching';
import PhotoWall from '../../../components/PhotoWall/PhotoWall';


import './AboutUs.less'

const AboutUs = () =>{

  const [width, setWidth] = useState(window.innerWidth);
  useEffect(()=>{

    const handleResize = () => {
      setWidth(window.innerWidth);
    };
 
    // 添加事件监听器
    window.addEventListener('resize', handleResize);

    // 清理函数，组件卸载时移除事件监听器
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  },[])



  let expertList = [{
    img: require('../../../image/expert-ErwinSchrödinger.png'),
    name: '薛定谔(Erwin Schrödinger)',
    identity: '埃尔温·薛定谔(Erwin Schrödinger，1887年8月12日-1961年1月4日)，奥地利理论物理学家，量子力学奠基人之一。获933年诺贝尔物理学奖，',
    sentence: `“生命以'负熵'为生，生命本质上是一个通过不断从环境中汲取秩序，以抵抗自身趋向无序与平衡(死亡)的过程。”---《生命是什么--活细胞的物理面貌》`
  },{
    img: require('../../../image/expert-DouglasWallace.png'),
    name: 'Douglas Wallace',
    identity: '线粒体遗传学之父，费城儿童医院中心主任;曾任职于埃默里大学及加州大学欧文分校，美国国家科学院院士',
    sentence: `“线粒体DNA变异是决定人类适应气候、产生疾病及个体衰老的'生命时钟'。”`
  },{
    img: require('../../../image/expert-ZhenglongGu.png'),
    name: '顾正龙',
    identity: '国际知名遗传学家，复旦大学特聘教授，康奈尔大学客座教授。现任粤港澳大湾区精准医学研究院（广州）助理院长、线粒体遗传与健康研究中心主任',
    sentence: '“衰老就是一个组织失序的过程。随着时间流逝，线粒体功能下降，组织也越来越无序，很多疾病和可感知的衰老进程就发生了。”'
  },{
    img: require('../../../image/expert-NavdeepChandel.png'),
    name: 'Navdeep Chandel',
    identity: '西北大学费恩伯格医学院讲席教授;长期深耕线粒体活性氧(ROS)与代谢信号传导研究。',
    sentence: `“线粒体远不止是能量工厂，它通过释放信号分子指挥着细胞的免疫与生存决策。”`
  },{
    img: require('../../../image/expert-VamsiMootha.png'),
    name: 'Vamsi Mootha',
    identity: '哈佛医学院及麻省理工Broad研究所教授;霍华德·休斯医学研究所(HHMI)研究员。',
    sentence: '“通过绘制线粒体蛋白全谱(MitoCarta)，揭示了缺氧环境对修复功能的潜力。”'
  }]
  let AutoSwitchingData = {
    title: '科学家们的观点',
    data: expertList
  }
  
  
  let PhotoExpertList = [{
    type: 'icon',
    content: {
      top: <img src={require('../../../image/expert-ErwinSchrödinger.png')} style={{width:'100%'}} alt="" />,
      divider: false,
      title: '薛定谔',
      titleSize: 'clamp(14px, calc(13.65px + 0.09vw), 15px)',
      subTitle: '奥地利理论物理学家，量子力学奠基人之一',
      subTitleSize: 'clamp(14px, calc(13.65px + 0.09vw), 15px)',
      description: `“生命以'负熵'为生，生命本质上是一个通过不断从环境中汲取秩序，以抵抗自身趋向无序与平衡(死亡)的过程。”---《生命是什么--活细胞的物理面貌》`,
      descriptionSize: 'clamp(12px, calc(11.65px + 0.09vw), 13px)',
    },
    btnConfig: {
      icon: 'PlusOutlined',
      link: ''
    }
  },{
    type: 'icon',
    content: {
      top: <img src={require('../../../image/expert-DouglasWallace.png')} style={{width:'100%'}} alt="" />,
      divider: false,
      title: 'Douglas Wallace',
      titleSize: 'clamp(14px, calc(13.65px + 0.09vw), 15px)',
      subTitle: '线粒体遗传学之父,美国国家科学院院士',
      subTitleSize: 'clamp(14px, calc(13.65px + 0.09vw), 15px)',
      description: `“线粒体DNA变异是决定人类适应气候、产生疾病及个体衰老的'生命时钟'。”`,
      descriptionSize: 'clamp(12px, calc(11.65px + 0.09vw), 13px)',
    },
    btnConfig: {
      icon: 'PlusOutlined',
      link: ''
    }
  },{
    type: 'icon',
    content: {
      top: <img src={require('../../../image/expert-ZhenglongGu.png')} style={{width:'100%'}} alt="" />,
      divider: false,
      title: '顾正龙',
      titleSize: 'clamp(14px, calc(13.65px + 0.09vw), 15px)',
      subTitle: '科学顾问',
      subTitleSize: 'clamp(14px, calc(13.65px + 0.09vw), 15px)',
      description: '国际知名遗传学家，复旦大学特聘教授，康奈尔大学客座教授。研究方向主要集中在线粒体与疾病、基因组功能与进化、多基因调控网络的功能和进化等诸多领域，在多种顶级国际学术期刊上发表科技前沿逾60余篇，包括Nature、Nature Genetics、PNAS、Genome Research、FASEB、MBE、JBC等，文章被引用总计超4700次。',
      descriptionSize: 'clamp(12px, calc(11.65px + 0.09vw), 13px)',
    },
    btnConfig: {
      icon: 'PlusOutlined',
      link: ''
    }
  },{
    type: 'icon',
    content: {
      top: <img src={require('../../../image/expert-NavdeepChandel.png')} style={{width:'100%'}} alt="" />,
      divider: false,
      title: 'Navdeep Chandel',
      titleSize: 'clamp(14px, calc(13.65px + 0.09vw), 15px)',
      subTitle: '西北大学费恩伯格医学院讲席教授',
      subTitleSize: 'clamp(14px, calc(13.65px + 0.09vw), 15px)',
      description: '“线粒体远不止是能量工厂，它通过释放信号分子指挥着细胞的免疫与生存决策。”',
      descriptionSize: 'clamp(12px, calc(11.65px + 0.09vw), 13px)',
    },
    btnConfig: {
      icon: 'PlusOutlined',
      link: ''
    }
  },{
    type: 'icon',
    content: {
      top: <img src={require('../../../image/expert-VamsiMootha.png')} style={{width:'100%'}} alt="" />,
      divider: false,
      title: 'Vamsi Mootha',
      titleSize: 'clamp(14px, calc(13.65px + 0.09vw), 15px)',
      subTitle: '哈佛医学院及麻省理工Broad研究所教授;霍华德·休斯医学研究所(HHMI)研究员',
      subTitleSize: 'clamp(14px, calc(13.65px + 0.09vw), 15px)',
      description: '“通过绘制线粒体蛋白全谱(MitoCarta)，揭示了缺氧环境对修复功能的潜力。”',
      descriptionSize: 'clamp(12px, calc(11.65px + 0.09vw), 13px)',
    },
    btnConfig: {
      icon: 'PlusOutlined',
      link: ''
    }
  }]
  let PhotoWallData = {
    drawer: true,
    title: '这一切都是由一组顶尖科学家实现的',
    titleSize: 'clamp(32px, calc(27.07px + 1.31vw), 46px)',
    subTitle: '',
    subTitleSize: '',
    subTitle2: '科学和临床顾问',
    description: '我们得到了一组有成就的科学和临床顾问的知识和指导，他们的专业知识涵盖微生物组科学、基因组学、代谢组学、胃肠病学、免疫学、营养学、皮肤病学和人类临床研究。',
    descriptionSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)',
    data: PhotoExpertList
  }



  if(width > 770){
    return (
      <div className="AboutUs-page" style={{textAlign: 'left'}}>
        <div className="AboutUs-title">我们的愿景与使命</div>
        <div className="AboutUs-content">
          <div>我们的愿景是宏大且坚定的: 打破生理上限，助力人类实现健康生活至120岁的壮丽目标。在我们的视野中，未来你我们的每一刻都应被活力填满。我们一直聚焦以下领域:</div>
          <div>线粒体稳态维持(Mitochondrial Homeostasis): 我们通过技术手段优化线粒体的质量控制，确保生命的能量工厂在高压下，依然能保持卓越、稳定的能量输出，抑制机体退化。</div>
          <div>SASP衰老环境清除(Senescence-Scavenging): 我们致力于清除细胞间的"生化噪音"，净化受损的代谢微环境，防上衰老信号蔓延，恢复细胞间生态年轻化。</div>
          <div>线粒体移植技术(Mitochondrial Transplantation): 我们探索生命能量的再生机制，挑战并实现细胞层面的"动力重组”，替换受损机体的能量单元，让细胞重返健康状态。</div>
        </div>

        {/* 专家 */}
        {/* <AutoSwitching AutoSwitchingData={AutoSwitchingData}/> */}
        
        {/* 专家照片墙 */}
        <PhotoWall PhotoWallData={PhotoWallData}/>
      </div>
    )
  }else{
    return (
      <div className="AboutUs-page-phone" style={{textAlign: 'left'}}>
        <div className="AboutUs-title">我们的愿景与使命</div>
        <div className="AboutUs-content">
          <div>我们的愿景是宏大且坚定的: 打破生理上限，助力人类实现健康生活至120岁的壮丽目标。在我们的视野中，未来你我们的每一刻都应被活力填满。我们一直聚焦以下领域:</div>
          <div>线粒体稳态维持(Mitochondrial Homeostasis): 我们通过技术手段优化线粒体的质量控制，确保生命的能量工厂在高压下，依然能保持卓越、稳定的能量输出，抑制机体退化。</div>
          <div>SASP衰老环境清除(Senescence-Scavenging): 我们致力于清除细胞间的"生化噪音"，净化受损的代谢微环境，防上衰老信号蔓延，恢复细胞间生态年轻化。</div>
          <div>线粒体移植技术(Mitochondrial Transplantation): 我们探索生命能量的再生机制，挑战并实现细胞层面的"动力重组”，替换受损机体的能量单元，让细胞重返健康状态。</div>
        </div>
        
        {/* 专家 */}
        {/* <AutoSwitching AutoSwitchingData={AutoSwitchingData}/> */}
        {/* 专家照片墙 */}
        <PhotoWall PhotoWallData={PhotoWallData}/>
      </div>
    )
  }
}

export default AboutUs